import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-pointer-events-none tw-fixed tw-right-4 tw-top-4 tw-z-[9999] tw-flex tw-w-[min(420px,calc(100vw-2rem))] tw-flex-col tw-gap-2" }
const _hoisted_2 = { class: "tw-min-w-0 tw-flex-1 tw-text-left tw-text-sm tw-font-medium tw-text-slate-900 tw-leading-5" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "tw-absolute tw-bottom-0 tw-left-0 tw-h-[3px] tw-w-full tw-bg-slate-900/5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toastStore.toasts, (t) => {
      return (_openBlock(), _createElementBlock("div", {
        key: t.id,
        class: _normalizeClass(["tw-pointer-events-auto tw-relative tw-flex tw-items-center tw-justify-between tw-gap-3 tw-overflow-hidden tw-rounded-xl tw-border tw-bg-white/70 tw-backdrop-blur tw-px-4 tw-py-3 tw-shadow-lg tw-shadow-slate-900/10", _ctx.variantClass(t.variant)])
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(t.message), 1),
        _createElementVNode("button", {
          type: "button",
          class: "tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-text-slate-600 hover:tw-bg-white",
          onClick: ($event: any) => (_ctx.clearToast(t.id))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "xmark",
            class: "tw-h-3.5 tw-w-3.5"
          })
        ], 8, _hoisted_3),
        (t.timeoutMs > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["tw-h-full tw-transition-[width] tw-duration-75 tw-ease-linear", _ctx.progressBarClass(t.variant)]),
                style: _normalizeStyle({ width: `${_ctx.progressPercent(t)}%` })
              }, null, 6)
            ]))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}